/*
 * Route attributes for FX bucketing (decide / audience). Event page context
 * lives in optimizely-exp-page-context.
 */
import {classifyPage} from './optimizely-exp-page-context'

const MAX_PATH = 200

/**
 * Route attributes for FX bucketing. The pathname is the router path: no
 * origin, no query. page_type comes from the URL only — the PDP's async
 * product_set override is an event property, not a decision attribute.
 * @param {string} [pathname]
 * @returns {{pathname: string, page_type: string}}
 */
export const getFxAudiencePage = (pathname) => {
    const raw = String(pathname == null ? '/' : pathname)
        .split('?')[0]
        .split('#')[0]
    const path = raw.slice(0, MAX_PATH) || '/'
    return {pathname: path, page_type: classifyPage(path)}
}

/** True only for the literal query value `optly_qa=true`. */
export const readOptlyQa = (search) => {
    const raw = typeof search === 'string' ? search : ''
    return new URLSearchParams(raw).get('optly_qa') === 'true'
}
